module.exports = __webpack_public_path__ + "static/media/010.0ede950f.jpg";